import { useState } from 'react';
import { LEVEL_LABELS } from '../constants';
import FotoIntera from './FotoIntera';

function MusicianCard({ m, allRoles, levels, isAdmin, onEdit, onDelete, onToggleAdmin, onTogglePermission }) {
  const [open, setOpen] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  const canPrivate = m.can_create_private_events || false;
  const canPublic = m.can_create_public_events || false;

  return (
    <div className="musician-card">
      {fullscreen && <FotoIntera src={m.avatar_url} onClose={() => setFullscreen(false)}/>}
      <div className="musician-card-row" onClick={() => setOpen(o => !o)}>
        {m.avatar_url
          ? <img src={m.avatar_url} alt=""
              onClick={e => { e.stopPropagation(); setFullscreen(true); }}
              style={{width:52,height:52,borderRadius:'50%',objectFit:'cover',flexShrink:0,cursor:'pointer'}}/>
          : <div className="avatar"
              onClick={e => e.stopPropagation()}
              style={{width:52,height:52,fontSize:20,flexShrink:0}}>{m.name.charAt(0)}</div>
        }
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontWeight:700,fontSize:18,display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
            {m.name}
            {m.is_admin && <span className="badge-admin">ADMIN</span>}
            {m.requested_organizer && !canPrivate && !canPublic && (
              <span style={{fontSize:16,fontWeight:700,background:'rgba(237,180,29,0.15)',border:'1px solid rgba(237,180,29,0.4)',color:'#e6b800',borderRadius:999,padding:'2px 8px'}}>richiesta</span>
            )}
          </div>
          <div style={{display:'flex',gap:5,flexWrap:'wrap',marginTop:5}}>
            {allRoles.map(r => (
              <span key={r} style={{
                fontSize:16,
                background: 'rgba(237,77,29,0.08)',
                border: '1px solid rgba(237,77,29,0.15)',
                borderRadius:999,padding:'3px 10px',
                color: 'var(--text)',
                whiteSpace:'nowrap',
              }}>{r}</span>
            ))}
          </div>
        </div>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round"
          style={{flexShrink:0,marginLeft:6,transition:'transform .2s',transform:open?'rotate(180deg)':'rotate(0deg)'}}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {open && (
        <div className="musician-card-expand">
          {m.city && <div style={{fontSize:17,color:'var(--muted)',marginBottom:10}}>{m.city}</div>}
          {allRoles.length > 0 && (
            <div style={{marginBottom:10}}>
              {allRoles.map(r => (
                <div key={r} style={{display:'flex',alignItems:'center',gap:10,padding:'5px 0',borderBottom:'1px solid var(--border)'}}>
                  <span style={{fontSize:17,fontWeight:600,minWidth:100,color:'var(--text)'}}>{r}</span>
                  <span style={{fontSize:16,color:'var(--muted)'}}>
                    {levels[r] > 0 ? LEVEL_LABELS[levels[r]] : 'non indicato'}
                  </span>
                </div>
              ))}
            </div>
          )}
          {(m.genres||[]).length > 0 && (
            <div className="chip-group" style={{marginBottom:10}}>
              {m.genres.map(g => <span key={g} className="chip genre">{g}</span>)}
            </div>
          )}
          <div style={{display:'flex',flexDirection:'column',gap:6,marginBottom:10}}>
            {m.email && <a href={`mailto:${m.email}`} style={{fontSize:16,color:'var(--muted)'}} onClick={e=>e.stopPropagation()}>{m.email}</a>}
            {m.phone && <a href={`tel:${m.phone}`} style={{fontSize:16,color:'var(--muted)'}} onClick={e=>e.stopPropagation()}>{m.phone}</a>}
            {m.whatsapp_link && <a href={m.whatsapp_link} target="_blank" rel="noreferrer" style={{fontSize:16,color:'var(--text)'}} onClick={e=>e.stopPropagation()}>WhatsApp</a>}
          </div>
          {isAdmin && (
            <div style={{display:'flex',flexDirection:'column',gap:10}}>
              <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                <button className="btn btn-secondary btn-sm" onClick={e=>{e.stopPropagation();onEdit();}}>Modifica</button>
                <button className="btn btn-danger btn-sm" onClick={e=>{e.stopPropagation();onDelete();}}>Elimina</button>
                <button className={`btn btn-sm ${m.is_admin?'btn-danger':'btn-success'}`}
                  onClick={e=>{e.stopPropagation();onToggleAdmin();}}>
                  {m.is_admin ? 'Revoca admin' : 'Nomina admin'}
                </button>
              </div>
              {/* Permessi organizzazione serate */}
              <div style={{padding:'10px 12px',background:'rgba(255,255,255,0.04)',borderRadius:10,border:'1px solid rgba(255,255,255,0.07)'}}>
                <div style={{fontSize:16,fontWeight:700,color:'var(--muted)',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.08em'}}>Permessi serate</div>
                <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                  <button
                    onClick={e=>{e.stopPropagation();onTogglePermission(!canPrivate, canPublic);}}
                    style={{padding:'6px 12px',borderRadius:8,fontSize:16,fontWeight:600,cursor:'pointer',border:'none',
                      background: canPrivate ? 'rgba(237,77,29,0.2)' : 'rgba(255,255,255,0.07)',
                      color: canPrivate ? '#ED4D1D' : 'var(--muted)'}}>
                    Privata: {canPrivate ? 'SI' : 'NO'}
                  </button>
                  <button
                    onClick={e=>{e.stopPropagation();onTogglePermission(canPrivate, !canPublic);}}
                    style={{padding:'6px 12px',borderRadius:8,fontSize:16,fontWeight:600,cursor:'pointer',border:'none',
                      background: canPublic ? 'rgba(237,77,29,0.2)' : 'rgba(255,255,255,0.07)',
                      color: canPublic ? '#ED4D1D' : 'var(--muted)'}}>
                    Pubblica: {canPublic ? 'SI' : 'NO'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MusicianCard;
